var $46b5e56b51e04cd5$exports = {};
$46b5e56b51e04cd5$exports = {
    "actions": `Toiminnot`,
    "hideButtonLabel": `N\xe4yt\xe4 v\xe4hemm\xe4n`,
    "noTags": `Ei mit\xe4\xe4n`,
    "showAllButtonLabel": (args, formatter)=>`N\xe4yt\xe4 kaikki (${formatter.number(args.tagCount)})`
};


export {$46b5e56b51e04cd5$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
